// extracted by mini-css-extract-plugin
module.exports = {"actions":"Table_actions__3UzSw","colMaxWidth":"Table_colMaxWidth__Hn7pL"};